/**
 * @author vishwadeep.kapoor
 * @Date: 2020-11-20 18:00:03
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-20 18:39:20
 */

import React, { Fragment } from 'react';
import { Row, Col, Icon } from 'antd';
import { Link } from 'react-router-dom';
import endPoints from '../../../../config/endPoints';
import { constants } from '../../../../devUtils';
import { SubTitle, LandingContainer } from '../../../../components';

const Sme = () => (
  <Fragment>
    <section className="section-solution">
      <Row align="middle" type="flex" justify="start">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <img
            src={endPoints.BUILT_EVERYONE_SMES.URL}
            alt={endPoints.BUILT_EVERYONE_SMES.ALT}
            className="width-100 img-grayscale"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="padding-l-5">
          <h2 className="font-18"><b>SMEs</b></h2>
          <p>
            Our intuitive and simple to use software platforms can help you focus on improving your<br />
            team’s productivity, save time and energy. By working within our centralised workspace,<br />
            you’ll have all the tools you need to keep track of your financial operations.
          </p>
          <Row align="middle" type="flex" justify="start" className="padding-1">
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_TEAM_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_TEAM_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                A management dashboard through which companies can add cardholders and<br />
                set individual limits based on business needs.
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-1"></Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_CARD_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_CARD_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Easier Budgeting and Allocation with Points-based Rewards and Social<br />
                Recognition to promote employee motivation, fosters workplace efficiency.
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-1"></Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_FLOW_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_FLOW_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Our financial management & analytics tool will help SMEs/startups to take<br />
                informed financial decisions and aid in streamlining their financial operations.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <div className="text-center padding-tb-2">
          <SubTitle fontWeight="900" className="font-26">Reach new heights with the Zaggle automated<br />services and products
          </SubTitle>
        </div>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>An overwhelming memory</h2>
            <p>
              An exclusive Zaggle multi-brand card gifted to an employee by the enterprise can make him feel very special and over-whelmed. It gives the employees a sense of personalization which uplifts their efficiency and productivity.
              <br /><br />
              The small and medium enterprises can also use these cards for co-branding by engraving their names on the envelope.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.SME_OVER.URL}
              alt={endPoints.SME_OVER.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.SME_EMPLOYEE.URL}
              alt={endPoints.SME_EMPLOYEE.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>An integrated and comprehensive employee management</h2>
            <p>
              Propel is a comprehensive and easy way to manage rewards programs for employees and channel partners. It is a configurable, automated, and customizable reward and sharing platform.
              <br /><br />
              SME can make optimized use of this application for multiple operations like workflow automation, employee engagement, and customized offerings.
            </p>
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Lower the unauthorized spent</h2>
            <p>
              Zaggle EMS helps SME in capturing a complete overview of employee expense management in a single integrated dashboard.
              <br /><br />
              It cut -down the huge amount spent on expense reporting and manual work.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.SME_LOWER.URL}
              alt={endPoints.SME_LOWER.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="gray-greadient text-center padding-tb-5">
      <LandingContainer>
        <SubTitle fontWeight="900" className="font-26">
          See how Zaggle products can fit your needs
        </SubTitle>
        <Link to={constants.LINK_CONTACTUS} className="btn red-btn">CONNECT WITH EXPERT NOW<Icon type="right" /></Link>
      </LandingContainer>
    </section>
  </Fragment>
);

export default Sme;



// WEBPACK FOOTER //
// client/containers/NewLanding/Solutions/SME/index.js